import Request from 'gd-request';

class ApiTodoListTemplate {

    create(companyId, name, todoList=[]) {
        return new Request(this,'POST','company/'+companyId+'/todo-list-templates',{
            name: name,
            todoList: todoList
        });
    }

    updateSortPositions(companyId, arrIds) {
        return new Request(this,'PUT','company/'+companyId+'/todo-list-templates',{
            arrIds: arrIds
        });
    }

    update(companyId, todoListTemplateId, name, todoList) {
        return new Request(this,'PUT','company/'+companyId+'/todo-list-template/'+todoListTemplateId,{
            name: name,
            todoList: todoList
        });
    }

    delete(companyId, todoListTemplateId) {
        return new Request(this,'DELETE','company/'+companyId+'/todo-list-template/'+todoListTemplateId);
    }

}

module.exports = ApiTodoListTemplate;